export const REPORT_KEYS = {
    OPERATIONS_ADMINISTRATION: 'operations-administration',
    ERRORES_GENERALES: 'errores-generales',
    OPERACIONES_BASICAS_USUARIO: 'operaciones-basicas-usuario',
    OPERACIONES_USUARIO_FINAL: 'operaciones-usuario-final',
    LICENCIAS: 'licencias',
    CONCURRENCIA_ACTUAL: 'concurrencia-actual'
};

export const REPORT_MENU_ITEMS = [
    {
        key: 'OperationsAdministration',
        reportKey: REPORT_KEYS.OPERATIONS_ADMINISTRATION,
        controlKey: 'lblAdminiOperationsReport'
    },
    {
        key: 'GeneralErrors',
        reportKey: REPORT_KEYS.ERRORES_GENERALES,
        controlKey: 'lblGeneralErrorsReport'
    },
    {
        key: 'BasicUserOperations',
        reportKey: REPORT_KEYS.OPERACIONES_BASICAS_USUARIO,
        controlKey: 'lblBasicUserOperationsReport'
    },
    {
        key: 'EndUserOperations',
        reportKey: REPORT_KEYS.OPERACIONES_USUARIO_FINAL,
        controlKey: 'lblEndUserOperationsReport'
    },
    {
        key: 'Licenses',
        reportKey: REPORT_KEYS.LICENCIAS,
        controlKey: 'lblLicensesReport'
    },
    {
        key: 'CurrentConcurrency',
        reportKey: REPORT_KEYS.CONCURRENCIA_ACTUAL,
        controlKey: 'lblCurrentConcurrencyReport'
    }
];